import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../../../../@fury/shared/material-components.module';
import { ScrollbarModule } from '../../../../@fury/shared/scrollbar/scrollbar.module';
import { EditorComponent } from './editor.component';
import { LoadingOverlayModule } from '../../../../@fury/shared/loading-overlay/loading-overlay.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuryAlertBoxModule } from '../../../../@fury/shared/alert-box/alert-box.module';
import { MtxDatetimepickerModule } from '@ng-matero/extensions/datetimepicker';
import { LightboxModule } from 'ng-gallery/lightbox';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { RouterModule } from '@angular/router';
import { QuillModule } from 'ngx-quill';
import { HistoryComponent } from './history/history.component';
import { PageHeaderButtonsModule } from '../../../../@fury/shared/page-header-buttons/page-header-buttons.module';
import { ForwardDialogComponent } from './forward-dialog/forward-dialog.component';
import { ReassignDialogComponent } from './reassign-dialog/reassign-dialog.component';
import { ConfirmLosingChangesDialogComponent } from './confirm-losing-changes-dialog/confirm-losing-changes-dialog.component';
import { TableFiltersModule } from '../../../../@fury/shared/table-filters/table-filters/table-filters.module';
import { MatChipsModule } from '@angular/material/chips';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { NgxMaskModule } from 'ngx-mask';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FurySharedModule } from '../../../../@fury/fury-shared.module';
import { AttachmentModule } from '../../../../@fury/shared/attachment/attachment.module';
import { LeafletMapService } from '../../../services/base/leaflet-map.service';
import { PipesModule } from '../../../../@fury/utils/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ScrollbarModule,
    LoadingOverlayModule,
    ReactiveFormsModule,
    FuryAlertBoxModule,
    MtxDatetimepickerModule,
    LightboxModule,
    MaterialFileInputModule,
    RouterModule,
    QuillModule,
    PageHeaderButtonsModule,
    FormsModule,
    TableFiltersModule,
    MatChipsModule,
    LeafletModule,
    NgxMaskModule,
    NgxMatSelectSearchModule,
    FurySharedModule,
    AttachmentModule,
    PipesModule,
  ],
  declarations: [
    EditorComponent,
    HistoryComponent,
    ForwardDialogComponent,
    ReassignDialogComponent,
    ConfirmLosingChangesDialogComponent,
  ],
  exports: [
    EditorComponent,
    HistoryComponent,
    ForwardDialogComponent,
    ReassignDialogComponent,
    ConfirmLosingChangesDialogComponent,
  ],
  providers: [
    LeafletMapService
  ]
})
export class EditorModule {
}
